import addPost from '../assets/images/allicons/addpost.svg'
import addUser from '../assets/images/allicons/adduser.svg'
import android from '../assets/images/allicons/android.svg'
import appStore from '../assets/images/allicons/appStore.svg'
import arrows_next from '../assets/images/allicons/arrows_next.svg'
import audio_waveform_blue from '../assets/images/allicons/audio_waveform_blue.svg'
import audio_waveform_gray from '../assets/images/allicons/audio_waveform_gray.svg'
import audio_waveform_white from '../assets/images/allicons/audio_waveform_white.svg'
import avatar_big from '../assets/images/allicons/avatar-big.svg'
import avatar_diamond from '../assets/images/allicons/avatar_diamond.svg'
import avatar_dollar from '../assets/images/allicons/avatar_dollar.svg'
import avatar_heart from '../assets/images/allicons/avatar_heart.svg'
import back from '../assets/images/allicons/back.svg'
import bigChatBubble from '../assets/images/allicons/bigChatBubble.svg'
import cameraBlack from '../assets/images/allicons/camera-black.svg'
import camera from '../assets/images/allicons/camera.svg'
import canada from '../assets/images/allicons/canada.svg'
import change_order from '../assets/images/allicons/change-order.svg'
import chat_outline_blue from '../assets/images/allicons/chat-outline-blue.svg'
import chat from '../assets/images/allicons/chat.svg'
import chat_img from '../assets/images/allicons/chat_img.svg'
import chat_imgb from '../assets/images/allicons/chat_imgb.svg'
import chat_imgb_active from '../assets/images/allicons/chat_imgb_active.svg'
import chat_mic from '../assets/images/allicons/chat_mic.svg'
import chat_vid from '../assets/images/allicons/chat_vid.svg'
import chatBubble from '../assets/images/allicons/chatbubble.svg'
import checkmark from '../assets/images/allicons/checkmark.svg'
import checkmark_outline_blue from '../assets/images/allicons/checkmark_outline_blue.svg'
import chevronRight from '../assets/images/allicons/chevronRight.svg'
import chrome from '../assets/images/allicons/chrome.svg'
import close from '../assets/images/allicons/close.svg'
import coins from '../assets/images/allicons/coins.svg'
import commentNtfc from '../assets/images/allicons/commentNtfc.svg'
import cookie from '../assets/images/allicons/cookie.svg'
import cropimg from '../assets/images/allicons/crop.svg'
import darkSend from '../assets/images/allicons/darkSend.svg'
import deactivateacc from '../assets/images/allicons/deactivateacc.svg'
import email_big from '../assets/images/allicons/email_big.svg'
import eye from '../assets/images/allicons/eye.svg'
import fans from '../assets/images/allicons/fans.svg'
import filter from '../assets/images/allicons/filter.svg'
import filterWhite from '../assets/images/allicons/filter_white.svg'
import friendRequest from '../assets/images/allicons/friendRequest.svg'
import friends from '../assets/images/allicons/friends.svg'
import globebubble from '../assets/images/allicons/globebubble.svg'
import google from '../assets/images/allicons/google.svg'
import googlePlay from '../assets/images/allicons/googlePlay.svg'
import heartActive from '../assets/images/allicons/heart-pink.svg'
import heart from '../assets/images/allicons/heart.svg'
import heartBlue from '../assets/images/allicons/heartBlue.svg'
import heartLine from '../assets/images/allicons/heartLine.svg'
import home from '../assets/images/allicons/home.svg'
import img from '../assets/images/allicons/img.svg'
import imgNtfc from '../assets/images/allicons/imgNtfc.svg'
import lightSend from '../assets/images/allicons/lightSend.svg'
import mailoutline from '../assets/images/allicons/mail_outline.svg'
import messagePlus from '../assets/images/allicons/messagePlus.svg'
import mobile from '../assets/images/allicons/mobile.svg'
import notifications from '../assets/images/allicons/notifications.svg'
import notificationssettings from '../assets/images/allicons/notificationssettings.svg'
import password_big from '../assets/images/allicons/password_big.svg'
import pause from '../assets/images/allicons/pauseaudio.svg'
import paxum from '../assets/images/allicons/paxum.svg'
import payment_bank from '../assets/images/allicons/payment_bank.svg'
import payment_bank_big from '../assets/images/allicons/payment_bank_big.svg'
import payment_plus from '../assets/images/allicons/payment_plus.svg'
import payout_bank_big from '../assets/images/allicons/payout_bank_big.svg'
import play from '../assets/images/allicons/play.svg'
import plus from '../assets/images/allicons/plus.svg'
import plusInCircleDashed from '../assets/images/allicons/plusInCircleDashed.svg'
import plusSquare from '../assets/images/allicons/plusSquare.svg'
import post from '../assets/images/allicons/post.svg'
import postsettings from '../assets/images/allicons/postsettings.svg'
import profile from '../assets/images/allicons/profile.svg'
import profile_black from '../assets/images/allicons/profile_black.svg'
import profile_lock from '../assets/images/allicons/profile_lock.svg'
import quotes from '../assets/images/allicons/quotes.svg'
import reload from '../assets/images/allicons/reload.svg'
import rotate from '../assets/images/allicons/rotate.svg'
import search from '../assets/images/allicons/search.svg'
import share from '../assets/images/allicons/share.svg'
import smile from '../assets/images/allicons/smile.svg'
import sortblack from '../assets/images/allicons/sort-black.svg'
import sort from '../assets/images/allicons/sort.svg'
import stonks from '../assets/images/allicons/stonks.svg'
import stop from '../assets/images/allicons/stop.svg'
import stream from '../assets/images/allicons/stream.svg'
import support_reply from '../assets/images/allicons/support_reply.svg'
import tickedBlueLeft from '../assets/images/allicons/tickedBlueLeft.svg'
import tickedBlueRight from '../assets/images/allicons/tickedBlueRight.svg'
import tickedGreyLeft from '../assets/images/allicons/tickedGreyLeft.svg'
import tickedGreyRight from '../assets/images/allicons/tickedGreyRight.svg'
import transactionCard from '../assets/images/allicons/transaction-card.svg'
import transactionWallet from '../assets/images/allicons/transaction-wallet.svg'
import trashsmall from '../assets/images/allicons/trash-small.svg'
import tutorial from '../assets/images/allicons/tutorial.svg'
import twitter from '../assets/images/allicons/twitter.svg'
import twitter_small from '../assets/images/allicons/twitter_small.svg'
import vhs from '../assets/images/allicons/vhs.svg'
import videoactive from '../assets/images/allicons/video-active.svg'
import videoNtfc from '../assets/images/allicons/videoNtfc.svg'

// settings
import navChatActive from '../assets/images/navigation/nav-chat-active.svg'
import navChat from '../assets/images/navigation/nav-chat.svg'
import navHomeActive from '../assets/images/navigation/nav-home-active.svg'
import navHome from '../assets/images/navigation/nav-home.svg'
import navNotificationsActive from '../assets/images/navigation/nav-notifications-active.svg'
import navNotifications from '../assets/images/navigation/nav-notifications.svg'
import navProfileActive from '../assets/images/navigation/nav-profile-active.svg'
import navProfile from '../assets/images/navigation/nav-profile.svg'
import premium_badge from '../assets/images/premium_badge.svg'
import bell from '../assets/images/settings/bell.svg'
import blockedusers from '../assets/images/settings/blocked-users.svg'
import chatsettings from '../assets/images/settings/chat.svg'
import chatblue from '../assets/images/settings/chatblue.svg'
import chatbubbles from '../assets/images/settings/chatbubbles.svg'
import coin from '../assets/images/settings/coin.svg'
import document from '../assets/images/settings/document.svg'
import earnings from '../assets/images/settings/earnings.svg'
import feed from '../assets/images/settings/feed.svg'
import geoblocking from '../assets/images/settings/geo-blocking.svg'
import login from '../assets/images/settings/log-in.svg'
import logout from '../assets/images/settings/log-out.svg'
import loginsessions from '../assets/images/settings/login-sessions.svg'
import mail from '../assets/images/settings/mail.svg'
import notification from '../assets/images/settings/notifications.svg'
import notificationsblue from '../assets/images/settings/notificationsblue.svg'
import payments from '../assets/images/settings/payments.svg'
import privacy from '../assets/images/settings/privacy.svg'
import avatar from '../assets/images/settings/profile.svg'
import scan from '../assets/images/settings/scan.svg'
import settings from '../assets/images/settings/settings.svg'
import settingsBlack from '../assets/images/settings/settingsBlack.svg'
import socialtrade from '../assets/images/settings/socialtrade.svg'
import statistics from '../assets/images/settings/statistics.svg'
import support from '../assets/images/settings/support.svg'
import trashbin from '../assets/images/settings/trash-bin.svg'
import unlock from '../assets/images/settings/unlock.svg'
import wallet from '../assets/images/settings/wallet.svg'

// navigation

interface Icons {
    [key: string]: string
    addPost: string
    addUser: string
    audio_waveform_white: string
    audio_waveform_blue: string
    audio_waveform_gray: string
    avatar_big: string
    avatar_heart: string
    avatar_dollar: string
    avatar_diamond: string
    arrows_next: string
    back: string
    bigChatBubble: string
    cameraBlack: string
    camera: string
    chat: string
    chat_outline_blue: string
    chat_img: string
    chat_imgb: string
    chat_imgb_active: string
    chat_mic: string
    chat_vid: string
    change_order: string
    chatBubble: string
    checkmark: string
    checkmark_outline_blue: string
    chevronRight: string
    close: string
    coins: string
    cookie: string
    cropimg: string
    deactivateacc: string
    eye: string
    fans: string
    friends: string
    filter: string
    filterWhite: string
    google: string
    globebubble: string
    heart: string
    heartLine: string
    heartBlue: string
    heartActive: string
    home: string
    img: string
    mailoutline: string
    mobile: string
    notifications: string
    notificationssettings: string
    play: string
    rotate: string
    videoNtfc: string
    imgNtfc: string
    commentNtfc: string
    payment_bank: string
    payment_bank_big: string
    payment_plus: string
    payout_bank_big: string
    plus: string
    plusSquare: string
    post: string
    postsettings: string
    profile: string
    profile_black: string
    profile_lock: string
    quotes: string
    reload: string
    sort: string
    support_reply: string
    sortblack: string
    search: string
    stop: string
    stonks: string
    twitter: string
    twitter_small: string
    tutorial: string
    vhs: string
    friendRequest: string
    pause: string
    videoactive: string
    trashsmall: string
    stream: string
    share: string
    chrome: string
    android: string
    canada: string
    password_big: string
    email_big: string
    googlePlay: string
    appStore: string
    plusInCircleDashed: string

    tickedGreyLeft: string
    tickedGreyRight: string
    tickedBlueLeft: string
    tickedBlueRight: string

    messagePlus: string
    smile: string
    lightSend: string
    darkSend: string

    bell: string
    blockedusers: string
    chatblue: string
    chatsettings: string
    chatbubbles: string
    coin: string
    document: string
    earnings: string
    feed: string
    login: string
    logout: string
    loginsessions: string
    geoblocking: string
    mail: string
    notification: string
    notificationsblue: string
    payments: string
    privacy: string
    scan: string
    avatar: string
    settings: string
    settingsBlack: string
    socialtrade: string
    statistics: string
    support: string
    unlock: string
    wallet: string
    trashbin: string

    navChat: string
    navChatActive: string
    navHome: string
    navHomeActive: string
    navNotifications: string
    navNotificationsActive: string
    navProfile: string
    navProfileActive: string

    premium_badge: string

    transactionWallet: string
    transactionCard: string
}

export const Icons: Icons = {
    premium_badge,
    addPost,
    addUser,
    audio_waveform_white,
    audio_waveform_blue,
    audio_waveform_gray,
    avatar_big,
    avatar_heart,
    avatar_dollar,
    avatar_diamond,
    arrows_next,
    back,
    bigChatBubble,
    cameraBlack,
    camera,
    chat,
    chat_outline_blue,
    chat_img,
    chat_imgb,
    chat_imgb_active,
    chat_mic,
    chat_vid,
    change_order,
    chatBubble,
    checkmark,
    checkmark_outline_blue,
    chevronRight,
    close,
    coins,
    cookie,
    cropimg,
    deactivateacc,
    eye,
    fans,
    friends,
    filter,
    filterWhite,
    google,
    globebubble,
    heart,
    heartLine,
    heartBlue,
    heartActive,
    home,
    img,
    mailoutline,
    mobile,
    notifications,
    notificationssettings,
    play,
    rotate,
    videoNtfc,
    imgNtfc,
    commentNtfc,
    payment_bank,
    payment_bank_big,
    paxum,
    payment_plus,
    payout_bank_big,
    plus,
    plusSquare,
    post,
    postsettings,
    profile,
    profile_black,
    profile_lock,
    quotes,
    reload,
    sort,
    sortblack,
    support_reply,
    search,
    stop,
    stonks,
    twitter,
    twitter_small,
    tutorial,
    vhs,
    friendRequest,
    pause,
    videoactive,
    trashsmall,
    stream,
    share,
    chrome,
    android,
    canada,
    password_big,
    email_big,
    googlePlay,
    appStore,
    plusInCircleDashed,

    tickedGreyLeft,
    tickedGreyRight,
    tickedBlueLeft,
    tickedBlueRight,

    messagePlus,
    smile,
    lightSend,
    darkSend,

    // settings
    bell,
    blockedusers,
    chatblue,
    chatsettings,
    chatbubbles,
    coin,
    document,
    earnings,
    feed,
    login,
    logout,
    loginsessions,
    geoblocking,
    mail,
    notification,
    notificationsblue,
    payments,
    privacy,
    scan,
    avatar,
    settings,
    settingsBlack,
    socialtrade,
    statistics,
    support,
    unlock,
    wallet,
    trashbin,

    // navigation
    navChat,
    navChatActive,
    navHome,
    navHomeActive,
    navNotifications,
    navNotificationsActive,
    navProfile,
    navProfileActive,

    transactionCard,
    transactionWallet
}
